/* eslint-disable @typescript-eslint/no-explicit-any */
import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize'
import { cn } from '~/lib/utils'

const schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    a: [...(defaultSchema.attributes?.a || []), 'target', 'rel']
  }
}

// Custom renderers for subscript and superscript
const renderers = {
  sub: ({ children }: { children?: React.ReactNode }) => <sub>{children}</sub>,
  sup: ({ children }: { children?: React.ReactNode }) => <sup>{children}</sup>
}

const MarkDown = ({ content, components, className }: any) => {
  return (
    <Markdown
      rehypePlugins={[rehypeRaw, [rehypeSanitize, schema]]}
      components={{ ...renderers, ...components }}
      className={cn('max-w-[80ch] text-pretty', className)}
    >
      {content}
    </Markdown>
  )
}

export default MarkDown
